import { useState } from 'react';
import { alpha } from '@mui/material/styles';
import { Box, Divider, Typography, Stack, MenuItem, Avatar, IconButton, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { signOut } from 'src/redux/features/auth/slice';
import logo from '../../../assets/JMC Concrete Official Logo .jpeg';
import { useNavigate } from 'react-router-dom';
import { t } from 'i18next';
import { DELETE_NOTIFICATION_TOKEN } from 'src/apiService/apiDeclaration';
import { retrieveData } from 'src/helper/storageHelper';
import { constants } from 'src/constants';

const MENU_OPTIONS = [];

export default function AccountPopover() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };
  const handleDeleteToken = async () => {
    const token = retrieveData(constants.notificationToken);
    const body = {
      notificationToken: token,
    };
    await DELETE_NOTIFICATION_TOKEN(body);
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          p: 0,
          ...(open && {
            '&:before': {
              zIndex: 1,
              content: "''",
              width: '100%',
              height: '100%',
              borderRadius: '50%',
              position: 'absolute',
              bgcolor: (theme) => alpha(theme.palette.grey[900], 0.8),
            },
          }),
        }}
      >
        <Avatar imgProps={{ style: { objectFit: 'contain' } }} src={logo} alt="photoURL" />
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 0,
            mt: 1.5,
            ml: 0.75,
            width: 180,
            '& .MuiMenuItem-root': {
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: { md: 1.5, xs: 0.8 }, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {user?.name}
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
            {user?.email}
          </Typography>
        </Box>

        <Stack sx={{ p: { md: 1, xs: 0.2 } }}>
          {MENU_OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={handleClose}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />
        <MenuItem sx={{ m: { md: 1, xs: 0.2 }, textWrap: 'wrap' }} onClick={() => navigate('/profile')}>
          {t('common.profile')}
        </MenuItem>

        <MenuItem sx={{ m: { md: 1, xs: 0.2 }, textWrap: 'wrap' }} onClick={() => navigate('/user/reset-password')}>
          {t('common.resetPass')}
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDeleteToken();
            handleClose();
            dispatch(signOut());
          }}
          sx={{ m: { md: 1, xs: 0.2 } }}
        >
          {t('common.logOut')}
        </MenuItem>
      </Popover>
    </>
  );
}
